export type ThemePreference = "system" | "light" | "dark";
export const THEME_KV_KEY = "theme";

/** Applies the preference to `<html data-theme>`; tokens.css reads it. */
export function applyTheme(pref: ThemePreference | undefined): void {
  const root = document.documentElement;
  if (!pref || pref === "system") delete root.dataset.theme;
  else root.dataset.theme = pref;

  // Keep browser chrome in sync with explicit themes; media tags handle OS changes.
  for (const scheme of ["light", "dark"] as const) {
    const meta = document.querySelector<HTMLMetaElement>(
      `meta[name="theme-color"][media="(prefers-color-scheme: ${scheme})"]`,
    );
    const effective = !pref || pref === "system" ? scheme : pref;
    meta?.setAttribute("content", effective === "dark" ? "#1f2422" : "#f3f4f3");
  }
}

export function nextTheme(pref: ThemePreference | undefined): ThemePreference {
  const prefersDark =
    typeof matchMedia === "function" && matchMedia("(prefers-color-scheme: dark)").matches;
  const effective = !pref || pref === "system" ? (prefersDark ? "dark" : "light") : pref;
  return effective === "dark" ? "light" : "dark";
}
